module.exports = __webpack_public_path__ + "static/img/index-tag-bg.07bab24f.png";